// https://github.com/alexfoxy/laxxx
// import AOS from 'aos';
export default () => {
    window.onload = function () {
        AOS.init();
    };
};
